import { Images } from '@/assets/images';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {};

type IValues = typeof initializeValue;

export const EMPLOYER_DEDUCTION_POINTS_CALCULATION_STANDARDS_VIOLATE_THE_COMPLIANCE_CONTENTS_CONFIG: FormConfig<IValues> =
	{
		initializeValue,
		title: '준수사항 위반 고용주 벌점 부과 기준',
		pages: [
			{
				background: {
					src: Images.formEmployerDeductionPointsCalculationStandardsViolateTheComplianceContents,
				},
			},
		],
	};
